export default __webpack_public_path__ + "static/media/Gopika G.8afae73c.jpg";